var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#4540DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5462 11.2313H20.6255L18.8774 9.44625C18.8774 9.44625 18.8688 9.4375 18.8644 9.4375L18.8558 9.42875C18.5962 9.16625 18.2457 9 17.8476 9H14.213C13.7889 9 13.4125 9.18375 13.1486 9.47688V9.48125L11.4394 11.2313H8.45385C7.64904 11.2313 7 11.87 7 12.6837V21.5256C7 22.3394 7.64904 23 8.45385 23H23.5462C24.3466 23 25 22.3394 25 21.5256V12.6837C25 11.87 24.3466 11.2313 23.5462 11.2313ZM16 20.7906C13.7976 20.7906 12.0019 18.9706 12.0019 16.7394C12.0019 14.5037 13.7976 12.6881 16 12.6881C18.2067 12.6881 19.9981 14.5037 19.9981 16.7394C19.9981 18.9706 18.2067 20.7906 16 20.7906ZM23.2736 13.5719C22.9404 13.5719 22.6678 13.2962 22.6678 12.955C22.6678 12.6137 22.9404 12.3381 23.2736 12.3381C23.6067 12.3381 23.8793 12.6137 23.8793 12.955C23.8793 13.2962 23.6067 13.5719 23.2736 13.5719Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 13.6768C14.3305 13.6768 12.9805 15.0461 12.9805 16.7393C12.9805 18.428 14.3305 19.8018 16.0007 19.8018C17.6665 19.8018 19.0209 18.4324 19.0209 16.7393C19.0209 15.0461 17.6665 13.6768 16.0007 13.6768Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.ec26202eefe06c9eeb691fdc63ef9ec9.svg";
export { ForwardRef as ReactComponent };